import { ValueOf } from './util';

/** 有効期限タイプのenum */
export const expiredDatePatterns = {
  DAYS_LATER: '付与日からN日後',
  MONTHS_LATER_MONTH_END: '付与日からNヶ月後の月末',
  YEARS_LATER_SPECIFIC_MONTH_END: '付与日からN年後の指定月の月末',
  SPECIFICATION: '期日指定',
  INDEFINITE: '無期限',
  INDIVIDUAL: 'CSVファイルで個別指定',
  BONUS_VALUE_CARD_EXPIRE: 'ボーナスバリューの有効期限設定に従う',
} as const;

export type ExpiredDatePatternsKey = keyof typeof expiredDatePatterns;
export type ExpiredDatePatternsValue = ValueOf<typeof expiredDatePatterns>;

export const expiredDatePatternKeys = Object.keys(expiredDatePatterns) as (ExpiredDatePatternsKey[]);

/** v-select用items */
export const expiredDatePatternItems = expiredDatePatternKeys
  .map((key) => ({
    title: expiredDatePatterns[key],
    value: key,
  }));
